import React from "react";
import { Link } from "react-router-dom";

export default function AuthLayout({ title, subtitle, children, image }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#F8FAFC]">
      <div className="flex flex-col justify-center px-6 sm:px-12 lg:px-16 py-10">
        <div className="w-full max-w-md mx-auto animate-fade-up">
          <Link to="/" className="inline-block mb-10">
            <img src="/manogene-logo.png" alt="ManoGene" className="h-8 w-auto" />
          </Link>
          <h1 className="font-head text-3xl font-bold text-ink tracking-tight">{title}</h1>
          {subtitle && <p className="mt-2 text-ink-soft">{subtitle}</p>}
          <div className="mt-8">{children}</div>
        </div>
      </div>
      <div className="hidden lg:block relative">
        <img
          src={image || "https://images.unsplash.com/photo-1666214277657-e60f05c40b04"}
          alt="Clinical"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-brand/40" />
        <div className="absolute bottom-10 left-10 right-10 text-white">
          <p className="font-head text-2xl font-semibold leading-snug">
            One MANOGENE ID unifying voice, triage, genetics and clinical review.
          </p>
        </div>
      </div>
    </div>
  );
}

export function Field({ label, ...props }) {
  return (
    <label className="block mb-4">
      <span className="text-sm font-medium text-ink-soft">{label}</span>
      <input
        {...props}
        className="mt-1.5 w-full rounded-lg border border-slate-300 px-3.5 py-2.5 text-ink outline-none focus:border-brand focus:ring-2 focus:ring-brand/15 transition-colors"
      />
    </label>
  );
}

export function SubmitButton({ loading, children, ...props }) {
  return (
    <button
      {...props}
      disabled={loading || props.disabled}
      className="w-full rounded-lg bg-brand text-white font-semibold py-2.5 hover:bg-brand-hover transition-colors disabled:opacity-60"
    >
      {loading ? "Please wait…" : children}
    </button>
  );
}
